export interface QuickmatchRoutingState {
  searchPending: boolean;
  elapsedSec: number;
  timeoutSec: number;
  matchmakingSucceeded: boolean;
}

export type QuickmatchRoutingOutcome = "wait_for_match" | "route_real_opponent" | "fallback_to_bot";

export function resolveQuickmatchRouting(state: QuickmatchRoutingState): QuickmatchRoutingOutcome {
  if (state.matchmakingSucceeded) {
    return "route_real_opponent";
  }
  if (!state.searchPending) {
    return "wait_for_match";
  }
  if (state.elapsedSec >= state.timeoutSec) {
    return "fallback_to_bot";
  }
  return "wait_for_match";
}

export function shouldFallbackToBot(state: Omit<QuickmatchRoutingState, "matchmakingSucceeded">): boolean {
  return resolveQuickmatchRouting({ ...state, matchmakingSucceeded: false }) === "fallback_to_bot";
}
